module.exports = __webpack_public_path__ + "static/media/mk.b35723f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mk.png
// module id = 1922
// module chunks = 0